/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IInputOutputCollectionScope extends angular.IScope {
        collection: Wars.Domain.Model.Gis.GisInputOutputCollection;
        save: any;
        add: any;
        delete: any;
        isOutput: boolean;
        inputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection;
        addTextInput:any;
    }

    export class InputOutputCollection implements IDirective {
        public link($scope: IInputOutputCollectionScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/inputOutputCollection.html";
        public restrict: string = "E";
        public controller = ["$scope", 'mapConfigurationService', InputOutputCollectionController];
        public controllerAs = "controller";
        public scope: any = {
            collection: "=",
            isOutput: "@",
            inputCollection: "="
        };
    }

    export class InputOutputCollectionController {
        constructor(private $scope: IInputOutputCollectionScope, private mapConfigurationService: services.MapConfigurationService) {
            $scope.save = () => mapConfigurationService.saveAllChanges();
            $scope.add = (i) => this.add(i);
            $scope.delete = (i) => this.delete(i);
            $scope.addTextInput = () => this.addTextInput();
        }

        private delete(item: Wars.Domain.Model.Gis.GisInputOutput) {
            item.entityAspect.setDeleted();

            this.mapConfigurationService.saveAllChanges();
        }

        private addTextInput() {
            let newInputOutput = this.mapConfigurationService.createGisInputOutput();

            newInputOutput.name = "Text Input";
            newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.TextInput;

            this.$scope.collection.gisInputOutputs.push(newInputOutput);

            this.mapConfigurationService.saveAllChanges();
        }

        private add(input: Wars.Domain.Model.Gis.GisInputOutput) {
            let newInputOutput = this.mapConfigurationService.createGisInputOutput();

            newInputOutput.name = input.name;
            //newInputOutput\
            newInputOutput.type = input.type;
            newInputOutput.relatedGisInputOutput = input;

            this.$scope.collection.gisInputOutputs.push(newInputOutput);

            this.mapConfigurationService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('InputOutputCollection', []);